import { render } from "./BasisProductForm.vue?vue&type=template&id=6ebbe69e&scoped=true&ts=true"
import script from "./BasisProductForm.vue?vue&type=script&lang=ts"
export * from "./BasisProductForm.vue?vue&type=script&lang=ts"

import "./BasisProductForm.vue?vue&type=style&index=0&id=6ebbe69e&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebbe69e"]])

export default __exports__